import { PropTypes } from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './modal-window.style';
import React, { Component } from 'react';
import './common.scss';

export class ConfirmModalWindow extends Component {

  render() {
    const { show, onClose, title, children, css } = this.props;

      return(
        <div id="modal">
          <div className={show ? css.show : css.hide}>
            <div className={css.dialog}>
              <div className={css.content}>
                <div className={css.header}>
                  <button id='closeModal' type="button" className={css.closeButton} onClick={e => onClose(e, false)}>
                    <span aria-label="close">&times;</span>
                  </button>
                  <h4 className={css.title}>
                    {title}
                  </h4>
                </div>
                <div className={css.body}>
                  {children}
                </div>
                <div className={css.footer}>
                  <div>
                    <div>
                      <button
                        id='confirm'
                        className='btn btn-primary'
                        onClick={e => onClose(e, true)}>
                        Yes
                      </button>
                      <button
                        id='cancel'
                        className='btn btn-default'
                        onClick={e => onClose(e, false)}>
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={show ? css.backgroundShow : css.backgroundHide} />
        </div>
      );
  }
}

ConfirmModalWindow.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.any.isRequired,
  children: PropTypes.any,
}

export default styleable(defaultStyle) (ConfirmModalWindow);



// WEBPACK FOOTER //
// src/common/confirm-modal-window.js